import { AppBar, Box, Button, Grid, IconButton, ThemeProvider, Toolbar, Typography } from "@mui/material";
import {
    InsertChart as InsertChartIcon,
    LockReset as LockResetIcon,
    Logout as LogoutIcon,
    Menu as MenuIcon,
} from '@mui/icons-material';
import { StateContextPropertyType, useStateContext } from "../reducers";
import { drawerWidth, footerHeight, headerHeight } from "../utils/Common";
import { GridColorStyles } from "../expanded-theme";
import { useNavigate } from "react-router-dom";

function NavbarMobile()
{
    const {menuState, setMenuState}: StateContextPropertyType = useStateContext();
    const navigate = useNavigate();

    return (
        <AppBar
            position="fixed"
            sx={{
                width: { md: menuState?.showSidebar ? `calc(100vw - ${drawerWidth}px)` : "100vw" },
                ml: { md: `${drawerWidth}px` },
                height: headerHeight,
                top: `calc(100vh - ${headerHeight}px - ${footerHeight}px)`,
                '@supports (height: 100dvh)': {
                    top: `calc(100dvh - ${headerHeight}px - ${footerHeight}px)`,
                },
                boxShadow: "none",
                borderBottom: "#f0f0f0 solid 1px"
            }}
            className="bg-color-default"
        >
            <Box
                sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "start",
                    alignItems: "center",
                }}
            >
                <Grid
                    container
                    spacing={2}
                    alignItems="flex-start"
                    alignContent="flex-start"
                    justifyContent="flex-start"
                    sx={{
                        width: "100%",
                        height: "100%",
                        padding: 0,
                        margin: 0,
                    }}
                >
                    <ThemeProvider theme={GridColorStyles}>
                        <Grid
                            item
                            sm={3}
                            xs={3}
                            sx={{
                                width: "100%",
                                height: "100%",
                                padding: "0 !important",
                                margin: 0,
                            }}
                        >
                            <Button
                                variant="outlined"
                                color="white"
                                onClick={() => navigate("/dashboard")}
                                sx={{
                                    border: "none",
                                    height: "100%",
                                    width: "100%",
                                    padding: 0,
                                    margin: 0,
                                }}
                            >
                                <InsertChartIcon />
                            </Button>
                        </Grid>
                        <Grid
                            item
                            sm={3}
                            xs={3}
                            sx={{
                                width: "100%",
                                height: "100%",
                                padding: "0 !important",
                                margin: 0,
                            }}
                        >
                            <Button
                                variant="outlined"
                                color="white"
                                onClick={() => setMenuState({...menuState, type: "toggle", showSidebar: !menuState?.showSidebar})}
                                sx={{
                                    border: "none",
                                    height: "100%",
                                    width: "100%",
                                    padding: 0,
                                    margin: 0,
                                }}
                            >
                                <MenuIcon />
                            </Button>
                        </Grid>
                        <Grid
                            item
                            sm={3}
                            xs={3}
                            sx={{
                                width: "100%",
                                height: "100%",
                                padding: "0 !important",
                                margin: 0,
                            }}
                        >
                            <Button
                                variant="outlined"
                                color="white"
                                onClick={() => navigate("/change-password")}
                                sx={{
                                    border: "none",
                                    height: "100%",
                                    width: "100%",
                                    padding: 0,
                                    margin: 0,
                                }}
                            >
                                <LockResetIcon />
                            </Button>
                        </Grid>
                        <Grid
                            item
                            sm={3}
                            xs={3}
                            sx={{
                                width: "100%",
                                height: "100%",
                                padding: "0 !important",
                                margin: 0,
                            }}
                        >
                            <Button
                                variant="outlined"
                                color="white"
                                onClick={() => navigate("/logout")}
                                sx={{
                                    border: "none",
                                    height: "100%",
                                    width: "100%",
                                    padding: 0,
                                    margin: 0,
                                }}
                            >
                                <LogoutIcon />
                            </Button>
                        </Grid>
                    </ThemeProvider>
                </Grid>
            </Box>
        </AppBar>
    )
};

export default NavbarMobile;
